
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[slug]/page/[page]",
      function () {
        return require("private-next-pages/blog/category/[slug]/page/[page].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[slug]/page/[page]"])
      });
    }
  